/**
 * Per-module personalisation (governance ADR-033; UI contract rule 14). What one module does that
 * others do not is data in web/module-slots.json (kit default) and
 * web/instances/<name>/module-slots.json (the _project's choices). This file registers the named
 * panels those files may place; ai-portal registers none yet.
 */
import { setModuleSlots, type ModuleSlotsFile, type SlotPanelComponent } from "@evo-flywheel/ui";
import { kernel } from "../kernel";
import { instance } from "../instance";
import kitSlots from "../../module-slots.json";
import "./related";

export const PANELS = {} as Record<string, SlotPanelComponent>;

const instanceSlots = import.meta.glob("../../instances/*/module-slots.json", { eager: true, import: "default" }) as Record<string, ModuleSlotsFile>;

// Summary counts for agent-spine modules read the pack's /tables routes, like their lists
// (dataProviders.ts): the spine is not in the kernel entity store.
const SPINE = /^\/entities(\?|\/)(.*\btype=(activity|deliverable|journey_definition|journey_execution)\b)/;
const route = (path: string) => (SPINE.test(path) ? `/tables${path}` : path);

setModuleSlots({
  layers: [kitSlots as ModuleSlotsFile, instanceSlots[`../../instances/${instance.name}/module-slots.json`]],
  panels: PANELS,
  fetchKernel: (path) => kernel(route(path)),
});
